export default __webpack_public_path__ + "static/media/fire.01c8714a.svg";